import { styleVariables } from '../styles/variables';

export function animateListItemActive() {
  const startHeight = this.hostEl.offsetHeight;
  this._renderer.setStyle(this.hostEl, 'height', `${startHeight}px`);
  this._renderer.setStyle(this.subtitleWrapperEl, 'opacity', '0');
  this._renderer.setStyle(this.subtitleWrapperEl, 'display', 'block');
  const additionalHeight = this.subtitleWrapperEl.offsetHeight;
  const endHeight = startHeight + additionalHeight;
  const promises = [
    this._animation.animate({
      targets: this.hostEl,
      height: [startHeight, endHeight],
      easing: styleVariables.transitionCurveStandard,
      duration: this.animationDuration,
    }),
    this._animation.animate({
      targets: this.subtitleWrapperEl,
      opacity: [0, 1],
      transform: [`translateY(-16px)`, `translateY(0)`],
      easing: styleVariables.transitionCurveStandard,
      duration: this.animationDuration,
    }),
  ];

  return Promise.all(promises).then(() => {
    this._renderer.setStyle(this.subtitleWrapperEl, 'opacity', 1);
    this._renderer.setStyle(
      this.subtitleWrapperEl,
      'transform',
      'translateY(0px)'
    );
    this._renderer.setStyle(this.hostEl, 'height', null);
  });
}

export function animateListItemInactive() {
  const startHeight = this.hostEl.offsetHeight;
  this._renderer.setStyle(this.hostEl, 'height', `${startHeight}px`);
  const additionalHeight = this.subtitleWrapperEl.offsetHeight;
  const endHeight = startHeight - additionalHeight;
  const promises = [
    this._animation.animate({
      targets: this.hostEl,
      height: [startHeight, endHeight],
      easing: styleVariables.transitionCurveStandard,
      duration: this.animationDuration,
    }),
    this._animation.animate({
      targets: this.subtitleWrapperEl,
      opacity: [1, 0],
      transform: [`translateY(0px)`, `translateY(16px)`],
      easing: styleVariables.transitionCurveStandard,
      duration: this.animationDuration,
    }),
  ];

  return Promise.all(promises).then(() => {
    this._renderer.setStyle(this.hostEl, 'height', null);
    this._renderer.setStyle(this.subtitleWrapperEl, 'opacity', '0');
    this._renderer.setStyle(this.subtitleWrapperEl, 'display', 'none');
  });
}
